import store from '@/store';

const showGlobalError = msg => {
	store.commit('app/SET_GLOBAL_ERROR_MESSAGE', msg);
};

export { showGlobalError };
